module.exports = __webpack_public_path__ + "img/celebrate.5bf8a26d.svg";